import { postHostedOnboardingValidateOptions } from '@onefootprint/fetch-hosted';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { checkDeviceInfo } from '@/idv2/utils/get-device';
import { redirectAfterIdentify } from '@/idv2/utils/loader-navigation';
import { getLogger } from '@/idv2/utils/logger';

const { logInfo } = getLogger({ name: 'idv2', location: 'identify-validate' });

const validateSearchSchema = z.object({
  authToken: z.string(),
  isPasskeyAlreadyRegistered: z.boolean().optional().default(false),
});

export const Route = createFileRoute('/identify/validate')({
  validateSearch: validateSearchSchema,
  beforeLoad: async ({ context, search }) => {
    const { authToken, isPasskeyAlreadyRegistered } = search;

    // A failure reaches the error screen: falling back to the auth token would hand the tenant a user credential.
    const { validationToken } = await context.queryClient.fetchQuery(
      postHostedOnboardingValidateOptions({
        headers: { 'X-Fp-Authorization': authToken },
      }),
    );
    logInfo('Validation token generated');

    const device = await checkDeviceInfo();
    const shouldSkipPasskey = !device.hasSupportForWebauthn || isPasskeyAlreadyRegistered;

    if (shouldSkipPasskey) {
      throw await redirectAfterIdentify(context, { validationToken, authToken });
    }

    // Offer optional passkey registration
    throw redirect({
      to: '/identify/passkey-offer',
      search: { authToken, validationToken },
    });
  },
});
